import React from 'react';
import { useTranslation } from 'react-i18next';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { useSubmitField } from '../../../hooks/useSubmitField';

interface Props {
  className?: string;
  noBottomSpacing?: boolean;
}

const FIELD_NAME = 'matureContent';

const MatureCheckboxField: React.FC<Props> = ({
  className,
  noBottomSpacing,
}) => {
  const { t } = useTranslation();
  const {
    id,
    field: { onChange, value },
  } = useSubmitField(FIELD_NAME, {
    initAdapter: ({ deviation, tiers = [] }, { tierId }) => {
      const parentTier = tierId
        ? tiers.find(tier => tier.deviationId === tierId)
        : undefined;
      return deviation?.isMature || parentTier?.isMature;
    },
    submitAdapter: ({ matureContent }) => ({ is_mature: matureContent }),
  });

  return (
    <BooleanInput
      className={className}
      name={FIELD_NAME}
      id={id}
      value={value}
      onChange={onChange}
      type="checkbox"
      size="large"
      label={t('deviationSubmit.form.labelOptions.mature')}
      noBottomSpacing={noBottomSpacing}
    />
  );
};
MatureCheckboxField.displayName = 'MatureCheckboxField';

export default MatureCheckboxField;
